import { axiosInstance } from "@/api/apiClient";
import {
  AuthApi,
  AuthApiUsersViewsNinjaAuthEmailLoginRequest,
  AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest,
  AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest,
  AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest,
  AuthApiUsersViewsNinjaAuthRegisterUserRequest,
  AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest,
  AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest,
  AuthApiUsersViewsNinjaAuthValidateTokenRequest,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";
import { BASE_API } from "@/helpers/constants";
import { AxiosResponse } from "axios";

const api = new AuthApi(undefined, BASE_API, axiosInstance);

export type LoginResponse = {
  token: string;
  mobile?: string;
};

export const emailLogin = async (
  payload: AuthApiUsersViewsNinjaAuthEmailLoginRequest
) => {
  return api.usersViewsNinjaAuthEmailLogin.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig) as unknown as Promise<
    AxiosResponse<LoginResponse>
  >;
};

export const registerUser = async (
  payload: AuthApiUsersViewsNinjaAuthRegisterUserRequest
) => {
  return api.usersViewsNinjaAuthRegisterUser.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const magicLinkLogin = async (
  payload: AuthApiUsersViewsNinjaAuthMagicLinkLoginRequest
) => {
  return api.usersViewsNinjaAuthMagicLinkLogin.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig) as unknown as Promise<
    AxiosResponse<LoginResponse>
  >;
};

export const validateToken = async (
  payload: AuthApiUsersViewsNinjaAuthValidateTokenRequest
) => {
  return api.usersViewsNinjaAuthValidateToken.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const passwordResetConfirm = async (
  payload: AuthApiUsersViewsNinjaAuthPasswordResetConfirmRequest
) => {
  return api.usersViewsNinjaAuthPasswordResetConfirm.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const passwordResetRequest = async (
  payload: AuthApiUsersViewsNinjaAuthPasswordResetRequestRequest
) => {
  return api.usersViewsNinjaAuthPasswordResetRequest.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const sendVerificationEmail = async (
  payload: AuthApiUsersViewsNinjaAuthSendVerificationEmailRequest
) => {
  return api.usersViewsNinjaAuthSendVerificationEmail.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const sendMagicLoginLink = async (
  payload: AuthApiUsersViewsNinjaAuthSendMagicLoginLinkRequest
) => {
  return api.usersViewsNinjaAuthSendMagicLoginLink.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};
